import React from 'react';


import {BasicPage} from 'src/components/basic-page';
import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';
import {SECTION_NAME} from 'src/modules/live-agent-configurator/constants';

import {Group, Item} from '@pb/kit-component-group';

export const LiveAgentConfiguratorSkeleton = () => (
    <BasicPage
        title={SECTION_NAME}
        buttonsBlock={(
            <Group>
                <SkeletonItem width={135} height={32}/>
                <SkeletonItem width={135} height={32}/>
            </Group>
        )}>
        <Item className="pd-l">
            <Group direction="v" alignItems="start">
                <FormItemSkeleton labelWidth={75}>
                    <ResponsiveElementGroup>
                        {new Array(7).fill('').map((_s, index) => (
                            <Group key={index} direction="v" alignItems="start">
                                <CheckboxSkeleton labelWidth={54}/>
                                <FormItemSkeleton labelWidth={31}>
                                    <SkeletonItem width={120} height={32}/>
                                </FormItemSkeleton>
                                <FormItemSkeleton labelWidth={31}>
                                    <SkeletonItem width={120} height={32}/>
                                </FormItemSkeleton>
                            </Group>
                        ))}
                    </ResponsiveElementGroup>
                </FormItemSkeleton>
                <SkeletonItem width={236} height={16}/>
                <FormItemSkeleton labelWidth={73}>
                    <Group direction="v" alignItems="start">
                        <Group gap="xl" alignItems="start">
                            <SkeletonItem width={182} height={32}/>
                            <SkeletonItem width={67} height={20}/>
                        </Group>
                        <SkeletonItem width={70} height={20}/>
                    </Group>
                </FormItemSkeleton>
            </Group>
        </Item>
    </BasicPage>
);
